import { TOUR } from "../ActionTypes"

export const openTutor = type => {
	return {
		type: TOUR.OPEN_TOUR,
		payload: type
	}
}

export const closeTutor = () => {
	return {
		type: TOUR.CLOSE_TOUR
	}
}
